// extracted by mini-css-extract-plugin
module.exports = {"scrollToTop":"ScrollToTop_scrollToTop__Qw5D2","fadeIn":"ScrollToTop_fadeIn__7AZKH"};